import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Modal, Button } from '@/shared/ui';

/**
 * Global listener for `casalary:upgrade-required` (dispatched by the API client on any 402
 * plan-gate). Shows a single upgrade dialog for every gated action, so individual buttons don't
 * each need their own gate. Mounted once inside the authenticated app shell.
 */
export function UpgradeDialog() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    function onUpgrade(e: Event) {
      const detail = (e as CustomEvent<{ message?: string; code?: string }>).detail;
      setMessage(detail?.message ?? null);
      setOpen(true);
    }
    window.addEventListener('casalary:upgrade-required', onUpgrade);
    return () => window.removeEventListener('casalary:upgrade-required', onUpgrade);
  }, []);

  function seePlans() {
    setOpen(false);
    navigate('/settings/billing');
  }

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      title={t('billing.upgradeTitle')}
      size="sm"
      footer={
        <>
          <Button variant="ghost" onClick={() => setOpen(false)}>
            {t('billing.notNow')}
          </Button>
          <Button onClick={seePlans}>{t('billing.seePlans')}</Button>
        </>
      }
    >
      <p>{message || t('billing.upgradeBody')}</p>
      <p style={{ color: 'var(--text-light)', marginTop: 'var(--space-2)' }}>{t('billing.proPitch')}</p>
    </Modal>
  );
}
